import { createServerFn } from "@tanstack/react-start"
import { loadGuideSnapshotJson } from "@/lib/guide-snapshot.server"

// Prefetch of the read-only guide view's data for the guide route's loader, so
// the guide view itself renders on the server (crawlable, and no plain-text
// stand-in page before it). Direct Postgres — NEVER a self-fetch to our own
// /api/trpc, which deadlocks inside the render (see guide-meta.ts). The db code
// lives in `.server.ts`, imported only inside the handler so the compiler
// strips it from the client bundle.
//
// The snapshot comes back as a JSON string (plus its uuid): the snapshot's jsonb columns have loose shapes the
// server-fn serializer types reject, and a string also pins the exact tRPC wire
// shape (see guide-snapshot.server.ts).
export const fetchGuideSnapshotJson = createServerFn({ method: `GET` })
  .inputValidator((d: { id: string }) => d)
  .handler(async ({ data }): Promise<{ id: string; json: string } | null> => {
    return loadGuideSnapshotJson(data.id).catch(() => null)
  })
